<template>
  <div>
    <v-layout wrap>
      <v-flex shrink xs6>
        <v-text-field
          v-model="selectedFuelLevel[0]"
          class="mt-0"
          type="number"
          label="Br.stof start"
          step="10"
          min="0"
          max="100"
        ></v-text-field>
      </v-flex>

      <v-flex shrink xs6>
        <v-text-field
          v-model="selectedFuelLevel[1]"
          class="mt-0"
          type="number"
          label="Br.stof eind"
          step="10"
          min="0"
          max="100"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import * as utils from "@/utils/utils";
import moment from "moment";
import { _ } from "vue-underscore";
export default {
  name: "FuelSlider",
  components: {},
  data() {
    return {
      fuelOptions: [0, 100]
    };
  },
  props: ["fuelLevel"],
  computed: {
    selectedFuelLevel: {
      get() {
        return this.fuelLevel;
      },
      set(value) {
        this.$emit("setFuelLevel", value);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/subcomponents/FuelSlider.vue